import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Outlet, useNavigate } from 'react-router-dom';
import { useState } from 'react';

interface Props {
    window?: () => Window;
}

const drawerWidth = 240;


export const Layout = (props: Props) => {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                Wallet Tracker
            </Typography>
            <Divider />
            <Box sx={{ display: { xs: 'block', sm: 'none', marginBottom: 10 } }}>
                <Button key={'AddWallet'} sx={{ color: 'blue' }} onClick={() => navigate('/add-wallet')}>
                    {'Add Wallet'}
                </Button>
            </Box>
            <Box sx={{ display: { xs: 'block', sm: 'block' } }}>
                <Button key={'TransactionHistory'} sx={{ color: 'blue' }} onClick={() => navigate('/transactions')}>
                    {'Transaction History'}
                </Button>
            </Box>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav">
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                    >
                        Wallet Tracker
                    </Typography>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Button key={'AddWallet'} sx={{ color: '#fff' }} onClick={() => navigate('/add-wallet')}>
                            {'Add Wallet'}
                        </Button>
                    </Box>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Button key={'TransactionHistory'} sx={{ color: '#fff' }} onClick={() => navigate('/transactions')}>
                            {'Transaction History'}
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
            <Box component="main" sx={{ p: 3, display: 'block', width: '100%' }}>
                <Toolbar />
                <Outlet />
            </Box>
        </Box>
    );
}